/* ==========================================================================
   Rangées défilantes — commandes de défilement

   Les rangées qui débordent à droite (« Coups de cœur », la galerie UGC, les
   suggestions d'une fiche produit) se défilent nativement : c'est un simple
   « overflow-x: auto ». Au doigt, cela suffit. À la souris, non : la barre de
   défilement est masquée par la charte, et une molette verticale ne déplace
   pas une rangée horizontale. Il n'y avait donc, sur ordinateur, aucun moyen
   évident d'atteindre les produits suivants.

   Ce script ajoute les deux gestes attendus :
   - deux flèches, désactivées quand on est au bout ;
   - le glisser à la souris, avec un seuil pour ne pas transformer un clic sur
     une carte en glissement.

   Il ne touche pas au défilement tactile, qui fonctionnait déjà.
   ========================================================================== */

(function () {
  const SEUIL_GLISSEMENT = 6; // px parcourus avant de basculer en glissement

  const FLECHE = {
    prev: 'M15 5l-7 7 7 7',
    next: 'M9 5l7 7-7 7',
  };

  function creerFleche(sens, libelle) {
    const bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'sirito-scroller__arrow sirito-scroller__arrow--' + sens;
    bouton.setAttribute('aria-label', libelle);
    bouton.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"' +
      ' stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"' +
      ' focusable="false"><path d="' +
      FLECHE[sens] +
      '"/></svg>';
    return bouton;
  }

  function equiper(rail) {
    if (rail.dataset.siritoScroller === 'ok') return;
    rail.dataset.siritoScroller = 'ok';
    rail.classList.add('js-sirito-rail');

    /* Une enveloppe positionnée sert d'ancre aux flèches. Elle est neutre en
       mise en page : un bloc de la largeur du parent, exactement là où se
       trouvait la rangée. */
    const enveloppe = document.createElement('div');
    enveloppe.className = 'sirito-scroller-wrap';
    rail.parentNode.insertBefore(enveloppe, rail);
    enveloppe.appendChild(rail);

    const precedent = creerFleche('prev', 'Faire défiler vers la gauche');
    const suivant = creerFleche('next', 'Faire défiler vers la droite');
    enveloppe.appendChild(precedent);
    enveloppe.appendChild(suivant);

    /* Un cran vaut une carte : largeur du premier enfant plus la gouttière. */
    const pas = () => {
      const premier = rail.firstElementChild;
      const gouttiere = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return premier ? premier.getBoundingClientRect().width + gouttiere : rail.clientWidth * 0.8;
    };

    const majEtat = () => {
      const marge = 2; // tolérance sur les sous-pixels
      const debordement = rail.scrollWidth - rail.clientWidth;
      enveloppe.classList.toggle('sirito-scroller-wrap--inutile', debordement <= marge);
      precedent.disabled = rail.scrollLeft <= marge;
      suivant.disabled = rail.scrollLeft >= debordement - marge;
    };

    precedent.addEventListener('click', () => {
      rail.scrollBy({ left: -pas(), behavior: 'smooth' });
    });
    suivant.addEventListener('click', () => {
      rail.scrollBy({ left: pas(), behavior: 'smooth' });
    });

    rail.addEventListener('scroll', majEtat, { passive: true });
    window.addEventListener('resize', majEtat);
    if ('ResizeObserver' in window) new ResizeObserver(majEtat).observe(rail);
    majEtat();

    /* --- Glisser à la souris ---
       Réservé au pointeur fin : au doigt, le navigateur fait déjà mieux que
       nous. Le calage magnétique est suspendu le temps du geste, sans quoi il
       ramène la rangée sur une carte à chaque pixel parcouru. */
    let actif = false;
    let depart = 0;
    let departScroll = 0;
    let parcouru = 0;

    rail.addEventListener('pointerdown', (evt) => {
      if (evt.pointerType !== 'mouse' || evt.button !== 0) return;
      actif = true;
      parcouru = 0;
      depart = evt.clientX;
      departScroll = rail.scrollLeft;
      rail.style.scrollSnapType = 'none';
      rail.classList.add('sirito-scroller--grabbing');
    });

    rail.addEventListener('pointermove', (evt) => {
      if (!actif) return;
      const delta = evt.clientX - depart;
      if (Math.abs(delta) > parcouru) parcouru = Math.abs(delta);
      if (parcouru < SEUIL_GLISSEMENT) return;
      /* Au-delà du seuil, on capture le pointeur : le geste continue même si
         la souris sort de la rangée. */
      if (!rail.hasPointerCapture(evt.pointerId)) {
        /* Le navigateur refuse la capture si le pointeur n'est plus actif :
           ce n'est pas une raison d'interrompre le geste. */
        try {
          rail.setPointerCapture(evt.pointerId);
        } catch (e) {
          /* sans effet */
        }
      }
      rail.scrollLeft = departScroll - delta;
      evt.preventDefault();
    });

    const relacher = (evt) => {
      if (!actif) return;
      actif = false;
      rail.classList.remove('sirito-scroller--grabbing');
      rail.style.scrollSnapType = '';
      if (evt && rail.hasPointerCapture(evt.pointerId)) {
        try {
          rail.releasePointerCapture(evt.pointerId);
        } catch (e) {
          /* sans effet */
        }
      }
    };

    rail.addEventListener('pointerup', relacher);
    rail.addEventListener('pointercancel', relacher);

    /* Un glissement se termine par un clic sur la carte survolée : on l'annule
       si le pointeur a réellement parcouru du chemin. */
    rail.addEventListener(
      'click',
      (evt) => {
        if (parcouru >= SEUIL_GLISSEMENT) {
          evt.preventDefault();
          evt.stopPropagation();
          parcouru = 0;
        }
      },
      true
    );

    rail.addEventListener('dragstart', (evt) => {
      if (parcouru >= SEUIL_GLISSEMENT) evt.preventDefault();
    });
  }

  const equiperTout = (racine) => {
    (racine || document)
      .querySelectorAll('.sirito-scroller, .sirito-product__crosssell-row')
      .forEach(equiper);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => equiperTout());
  } else {
    equiperTout();
  }

  /* Le personnalisateur remonte une section entière : la nouvelle rangée
     arrive sans nos commandes. */
  document.addEventListener('shopify:section:load', (evt) => equiperTout(evt.target));
})();
